export const common = {
  appName: 'First Weeks',
  practiceTagline: 'A Families First Pediatrics companion',

  tabs: {
    home: 'Home',
    track: 'Track',
    history: 'History',
    guide: 'Guide',
  },

  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    done: 'Done',
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
    start: 'Start',
    stop: 'Stop',
    settings: 'Settings',
    confirmDelete: 'Delete this entry?',
  },

  eventTypes: {
    feed: 'Feeding',
    diaper: 'Diaper',
    weight: 'Weight',
    pump: 'Pumping',
    sleep: 'Sleep',
  },

  sides: {
    left: 'Left',
    right: 'Right',
    both: 'Both',
  },

  contents: {
    breastmilk: 'Breast milk',
    formula: 'Formula',
    mixed: 'Mixed',
  },

  time: {
    justNow: 'Just now',
    agoHM: (h: number, m: number) => (h > 0 ? `${h}h ${m}m ago` : `${m}m ago`),
    durationHM: (h: number, m: number) => (h > 0 ? `${h}h ${m}m` : `${m} min`),
    today: 'Today',
    yesterday: 'Yesterday',
    dayOfLife: (day: number) => `Day ${day}`,
  },

  sync: {
    idle: 'Synced',
    syncing: 'Syncing…',
    offline: 'Offline. Will sync when connected.',
    unpaired: 'Not connected to a partner',
    error: "Couldn't reach the sync service",
    loggedByPartner: 'Logged by partner',
    loggedByMom: 'Logged by mom',
  },

  disclaimer:
    'This app is for tracking and education. It is not medical advice and does not replace care from your pediatrician or lactation team. If you are worried about your baby, call the office.',
  emergencyNote: 'If this is an emergency, call 911.',

  loading: 'Loading…',
};
